import CONFIG from '../../config';

const cons = window.console;
let TEST = false;
const console = {
  ...cons,
  log: (...args) => {
    if (CONFIG.NODE_ENV === 'development' || TEST) {
      cons.log(args);
      if (!TEST) cons.trace();
    }
  },
  debug: (...args) => {
    if (CONFIG.DEBUG || TEST) {
      if (Array.isArray(args) && args[0] === "reducer") {
        console.log("reducer", args[1][1].type, args[1][0]);
      } else {
        cons.log(args);
      }
    }
  },
  assert: (status) => {
    TEST = !!status;
  }

};
export default { ...cons, ...console };
